import {ChangeDetectionStrategy, Component, Input, isDevMode, OnInit} from '@angular/core';

import {DialogService} from "@shared/services/dialog.service";

import {HandoverModel} from "@handover/view-models/handover.model";
import {
  HandoverLimitedAccessModalComponent
} from "@handover/routes/main-route/components/vehicle-handovers-list/components/handover-limited-access-modal/handover-limited-access-modal.component";

@Component({
  selector: 'handoverm-handover-menu',
  templateUrl: './handover-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverMenuComponent implements OnInit {

  @Input() model?: HandoverModel;

  constructor(
    private dialogService: DialogService
  ) {
  }

  ngOnInit(): void {
  }

  onCopyLink() {
    if (this.model?.isCreatedOnDesktop) {
      this.dialogService.open(HandoverLimitedAccessModalComponent);
      return;
    }

    navigator.clipboard.writeText(this.getHanoverUrl());
  }

  onPrint() {
    if (this.model?.isCreatedOnDesktop) {
      this.dialogService.open(HandoverLimitedAccessModalComponent);
      return;
    }

    window.open(this.getHanoverUrl(), '_blank')!.focus();
  }

  private getHanoverUrl(): string {
    const protocol = window.location.host.includes('localhost') ? 'http://' : 'https://';
    const url = `${protocol}${window.location.host}/handover/${this.model?.token}`;
    return url;
  }
}
